import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client'

import Shared from 'Services/Shared'

import {
  createAuthLink,
  createErrorLink,
  createRequestLink,
  createRetryLink,
} from './Links'
import typePolicies from './TypePolicies'

function createApolloClient() {
  const cache = new InMemoryCache({ typePolicies })

  const client = new ApolloClient({
    link: ApolloLink.from([
      createErrorLink(),
      createRetryLink(),
      createAuthLink(),
      createRequestLink(),
    ]),
    cache,
    connectToDevTools: true,
  })

  Shared.setApolloClient(client)

  return client
}

export { createApolloClient }
